/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React from "react";
import {
	Box,
	Flex,
	Heading,
	Text,
	Link as ExternalLink,
} from "@theme-ui/components";
import { ItemListContainer, CompliancesLink } from "./Utils";
import { typography, colors } from "../../styles/theme";
import { Button, Icon } from "../atoms";

export const RelatedCompliances = ({
	compliances,
	heading = "Related Compliances",
	isCustomLink = false,
}) => {
	const styles = {
		ul: {
			border: `1px solid ${colors.neutral200}`,
			borderRadius: "1.25rem",
			listStyleType: "none",
			p: "0 !important",
			li: {
				border: "none",
			},
		},
		heading: { ...typography.h6, mb: "1.125rem" },
	};

	return (
		<Box>
			<Heading sx={styles.heading}>{heading}</Heading>
			<Box
				as="ul"
				sx={styles.ul}
			>
				{compliances.map((compliance, index) => (
					<li
						style={{
							padding: "1rem",
							borderBottom:
								index === compliances.length - 1
									? ""
									: `1px solid ${colors.neutral200}`,
						}}
					>
						<CompliancesLink
							item={compliance}
							isCustomLink={isCustomLink}
						/>
					</li>
				))}
			</Box>
		</Box>
	);
};

export const ComplianceAttachments = ({ attachments }) => (
	<>
		{attachments.map(({ attachment, name, path }) => {
			const attachmentUrl = attachment ? attachment.url : path ? path : null;
			return (
				<Box my={"1.5rem"}>
					{attachmentUrl ? (
						<ExternalLink
							href={attachmentUrl}
							target="_blank"
						>
							<Button
								variant="outlined"
								size="large"
							>
								<Flex sx={{ alignItems: "center", gap: "0.5rem" }}>
									<Text sx={{ ...typography.textMd500, color: colors.primary1000 }}>{name}</Text>
									<Icon
										name="FileDown"
										color={colors.primary1000}
										size={24}
									/>
								</Flex>
							</Button>
						</ExternalLink>
					) : null}
				</Box>
			);
		})}
	</>
);

export const CompliancesList = ({ compliances, heading = "Compliances" }) => {
	if (compliances?.length <= 0) {
		return;
	}
	return (
		<ItemListContainer>
			{heading ? (
				<Heading
					sx={{
						...typography.h2,
						mt: ["3rem", "3rem", "4.5rem", "4.5rem"],
						mb: "1.5rem",
					}}
				>
					{heading}
				</Heading>
			) : null}
			<ul>
				{compliances.map((compliance) => (
					<li>
						<CompliancesLink item={compliance} />
					</li>
				))}
			</ul>
		</ItemListContainer>
	);
};
